import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'components/styles/language-toggle.css';
import PropTypes from 'prop-types';
import { LANGUAGES } from 'constants';

const LanguageToggle = ({ preselectLang, showLanguageToggle }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const applyLanguage =(lang) => {
    i18n.changeLanguage(lang);
    document.documentElement.dir = lang === LANGUAGES.ARABIC.langCode ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  };

  useEffect(() => {
    if (preselectLang) {
      applyLanguage(preselectLang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only primitives
  }, [preselectLang]);

  if (!showLanguageToggle) {
    return null;
  }

  return (
    <div className="language-toggle">
      <button
        className={`lang-btn ${currentLanguage === LANGUAGES.ENGLISH.langCode ? 'active' : ''}`}
        onClick={() => applyLanguage(LANGUAGES.ENGLISH.langCode)}
      >
        {LANGUAGES.ENGLISH.language}
      </button>
      <span className="lang-separator">|</span>
      <button
        className={`lang-btn ${currentLanguage === LANGUAGES.ARABIC.langCode ? 'active' : ''}`}
        onClick={() => applyLanguage(LANGUAGES.ARABIC.langCode)}
      >
        {LANGUAGES.ARABIC.language}
      </button>
    </div>
  );
};

LanguageToggle.propTypes = {
  preselectLang: PropTypes.string,
  showLanguageToggle: PropTypes.bool
};

export default LanguageToggle;
